export const initialContentState = {
  Content: [
    {
      selectPerks: {
        title: "Select perks",
        titleColor: "Gray-gray-headline-900",
        cta: {
          backgroundColor: "Gray-white",
          singlePerkTitle: "Select your {milestoneName} Perk",
          multiPerksTitle: "Select your {milestoneName} Perks",
          titleColor: "Gray-gray-headline-900",
          multiPerksSubTitle: "You earned a perk for reaching {milestoneName}! Select it by {MM/DD/YYYY}",
          singlePerkSubTitle: "You earned perks for reaching {milestoneName}! Select them by {MM/DD/YYYY}",
          subTitleColor: "Gray-gray-headline-900",
          leftIcon: "sparkle-stroke",
          leftIconCategory: "interface",
          leftIconColor: "ds-icon-emphasis-inverse",
          leftIconShadowColor: "ds-text-primary-default",
          leftIconForegroundColor: "ds-color-excursion-blue-800",
          ctaIcon: "chevron-right",
          ctaIconCategory: "interface",
          ctaIconColor: "Gray-gray-headline-800",
          actionUrl: "#",
        },
        backgroundColor: "gold-100",
      },
    },
    {
      perkSelection: {
        backgroundColor: "Gray-white",
        ctaButtonTitle: "Select",
        ctaDisabledBackgroundColor: "ds-color-excursion-grey-200",
        ctaDisabledColor: "ds-text-primary-inverse",
        ctaEnabledBackgroundColor: "ds-color-excursion-blue-900",
        ctaEnabledColor: "ds-text-primary-inverse",
        firstMultipleTitle: "First perk",
        secondMultipleTitle: "Second perk",
        title: "Select your perk",
        singlePerkWebTitle: "Choose one (1) perk",
        multiplePerksWebTitle: "Choose two (2) perks",
        titleColor: "ds-color-excursion-white-900",
        subtitle: "You will be able to confirm your choice in the next step.",
        subtitleColor: "ds-color-excursion-white-900",
        header: {
          backgroundColor: "ds-color-excursion-yellow-400",
          ctaColor: "ds-text-primary-default",
          subtitle: "Select your {milestone} perk.",
          multipleSubtitle: "Select your {milestone} perks.",
          subtitleColor: "ds-color-text-primary-default",
          title: "select your {count} {perks}",
          titleColor: "ds-text-primary-default",
          cta: {
            href: "#",
            title: "learn more about perks",
          },
        },
        infoIcon: "question-stroke",
        infoIconColor: "--Gray-gray-headline-800",
        infoIconCategory: "alert",
        infoContentColor: "ds-color-text-primary-default",
        confirmSelection: {
          backgroundColor: "Gray-white",
          title: "Confirm Selection?",
          titleColor: "Gray-gray-headline-900",
          subtitle: "Once you select your perks, this action can't be undone and your choice will be final",
          subtitleColor: "Gray-gray-headline-900",
          confirmButtonTitle: "Confirm",
          confirmButtonTextColor: "Gray-white",
          confirmButtonBackgroundColor: "ds-color-container-ui-primary-default-default",
          cancelButtonTitle: "Choose a different perk",
          cancelButtonBackgroundColor: "ds-color-border-ui-default-default",
          cancelButtonTextColor: "Gray-white",
          iconBackgroundColor: "ds-color-container-ui-primary-default-default",
          iconColor: "ds-color-container-ui-primary-default-default",
          confirmButtonDisabledBackgroundColor: "ds-color-excursion-grey-200",
          confirmButtonDisabledColor: "ds-text-primary-inverse",
          cancelButtonDisabledBorderColor: "ds-color-excursion-grey-200",
          cancelButtonDisabledColor: "ds-text-primary-inverse",
        },
        congratulationsSelection: {
          backgroundColor: "Gray-white",
          title: "Congrats!",
          titleColor: "Gray-gray-headline-900",
          singlePerkText: "You've successfully selected your {milestone} Milestone perk.",
          singlePerkColor: "Gray-gray-headline-900",
          multiplePerkText: "You've successfully selected your {milestone} Milestone perks.",
          multiplePerkColor: "Gray-gray-headline-900",
          buttonText: "Return to Perks",
          buttonTextColor: "Gray-white",
          buttonBackgroundColor: "ds-color-excursion-blue-900",
          iconBackgroundColor: "ds-color-excursion-blue-900",
          iconColor: "ds-color-excursion-blue-900",
        },
        top: {
          backgroundColor: "Green-green-200",
          leftIcon: "chevron-left",
          leftIconCategory: "interface",
          leftIconColor: "ds-text-primary-default",
          rightIcon: "x-sm",
          rightIconCategory: "interface",
          rightIconColor: "ds-text-primary-default",
          title: "Choose one (1) perk",
          multipleTitle: "Choose two (2) perks",
          titleColor: "Gray-gray-headline-800",
        },
        perk: {
          perkSelected: {
            borderColor: "ds-color-tier-alaska-primary-member-default",
            iconBackgroundColor: "ds-color-tier-alaska-primary-member-default",
            iconBorderColor: "ds-color-excursion-blue-900",
            iconColor: "ds-color-icon-ui-default-default",
            subtitleColor: "Gray-gray-headline-900",
            titleColor: "Gray-gray-headline-800",
          },
          perkUnselected: {
            borderColor: "ds-color-border-ui-default-default",
            iconBackgroundColor: "ds-text-primary-default",
            iconBorderColor: "ds-color-excursion-blue-900",
            iconColor: "ds-color-icon-ui-default-default",
            subtitleColor: "Gray-gray-headline-900",
            titleColor: "Gray-gray-headline-800",
          },
        },
      },
    },
    {
      icons: {
        list: [
          {
            perkId: "1",
            name: "food-and-drink",
            category: "in-flight",
          },
          {
            perkId: "2",
            name: "wifi",
            category: "in-flight",
          },
          {
            perkId: "3",
            name: "sparkle-stroke",
            category: "interface",
          },
          {
            perkId: "4",
            name: "elite-stroke",
            category: "in-flight",
          },
          {
            perkId: "5",
            name: "clear",
            category: "partnership",
          },
          {
            perkId: "6",
            name: "plane-diag-stroke",
            category: "terminal",
          },
        ],
        default: "sparkle-stroke",
        defaultCategory: "interface",
      },
    },
    {
      perksLanding: {
        title: "Perks",
        webTitle: "Mileage Plan Journey",
        titleColor: "ds-text-primary-default",
        backgroundColor: "gold-100",
        welcomeMessage:
          "As part of the new Alaska loyalty program, when you achieve a new milestone you'll be able to come here to select from a choice of perks.",
        welcomeMessageColor: "ds-text-primary-default",
        perksLaunch: {
          backgroundColorToken: "ds-blue-background-800",
          content:
            "<p>Congratulations! You are on your way to earning perks by collecting elite qualifying miles (EQM’s).</p><p><strong>You’ll be able to start unlocking any earned perks in February 2025.</strong></p><p>On your path to elite status, Alaska perks let you celebrate milestones by choosing rewards that are right for you—bonus miles, lounge passes, upgrade certificates, and more.</p>",
          headerText: "Arriving soon: Milestones and Perks",
          subHeaderText: "",
          ctaLink: {
            href: "https://www.alaskaair.com",
            title: "Learn more about perks",
          },
        },
        backButtonText: "Back",
        seeAllPerks: {
          title: "View complete list of perks",
          titleColor: "ds-text-primary-default",
          actionUrl:
            "https://www.alaskaair.com/content/mileage-plan/membership-benefits?lid=mileageplan:mileage-plan-overview:membership-benefits",
        },
        milestoneSummary: {
          currentMilestoneDetails: {
            milesProgressMessage: "{m} / {tm} elite-qualifying miles",
            nextPerkMilestoneMessage: "to {name} perks milestone",
            eliteQualifyingMiles: "{qm} Elite-qualifying miles",
            trialHeading: "Trial ends on {endDate}",
            trialMessage: "With {tierName}, you'll enjoy:",
          },
          upcomingMilestoneDetails: {
            remainingMilestoneDetails: "Only **{remaining-miles} more to go** until your {next-milestone-required}.",
          },
        },
        pastPerks: {
          linkColor: "Gray-gray-headline-900",
          iconBackgroundColor: "ds-color-tier-alaska-primary-member-default",
          iconBackgroundBorderColor: "ds-color-tier-alaska-primary-member-default",
          iconColor: "",
          cardBackgroundColor: "ds-color-container-primary-default",
          fieldTitleColor: "Gray-gray-headline-900",
          fieldValueColor: "Gray-gray-headline-900",
          perkTitleColor: "Gray-gray-headline-900",
          headerTitle: "Perks you have chosen.",
          statuses:{
            expiresSoonStatusBackgroundColor: "ds-color-background-yellow-default",
            appliedBalanceStatusBackgroundColor: "ds-color-excursion-blue-200",
            usedStatusBackgroundColor: "ds-color-excursion-blue-200",
            expiredStatusBackgroundColor: "ds-color-excursion-blue-200"
          }
        },
        topNav: {
          backgroundColor: "ds-color-excursion-blue-900",
          backIcon: "chevron-left",
          backIconCategory: "interface",
          backIconColor: "ds-color-excursion-white-900",
          title: "Perks",
          titleColor: "ds-color-excursion-white-900",

          infoBackgroundColor: "Gray-white",
          infoBackIconColor: "ds-color-text-emphasis-default",
          infoTitleColor: "ds-color-text-emphasis-default",
        },
      },
    },
    {
      perks: [
        {
          id: 6,
          perkSummary: "750 Bonus Miles",
          perkSelectionTileSubtitle: "",
          perkSelectionTileTitle: "750 Bonus Miles",
          items: ["Item 1", "Item 2"],
          confirmation: {
            additionalConfirmationText: "750 Bonus Miles Additional Confirmation Text",
            instruction: "instructions:"
          },
          termsAndConditions: {
            title: "",
            redeemInstructionRichText: "",
          },
        },
        {
          id: 7,
          perkSummary: "2500 Bonus Miles",
          perkSelectionTileTitle: "2500 Bonus Miles",
          perkSelectionTileSubtitle: "",
          items: ["Item 1", "Item 2"],
          confirmation: {
            additionalConfirmationText: "2500 Bonus Miles Additional Confirmation Text",
            instruction: "instructions:"
          },
          termsAndConditions: {
            title: "",
            redeemInstructionRichText: "",
          },
        },
        {
          id: 8,
          perkSummary: "5K Bonus Miles",
          perkSelectionTileSubtitle: "",
          perkSelectionTileTitle: "5K Bonus Miles",
          items: ["Item 1", "Item 2"],
          termsAndConditions: {
            title: "",
            redeemInstructionRichText: "",
          },
        },
        {
          id: 21,
          perkSummary: "$25 off a future Alaska flight",
          items: [],
          perkName: "",
          perkSelectionTileSubtitle: "",
          termsAndConditions: {
            title: "",
            redeemInstructionRichText: "",
          },
          pastPerksCardProps: {
            fields: [
              {
                title: "Book by",
                value: "benefitExpirationDate",
                order: 1,
              },
              {
                title: "Milestone",
                value: "milestoneRequiredMiles",
                order: 2,
              },
            ],
            links: [
              {
                title: "Redeem code",
                href: "https://www.alaskaair.com/search/?E={perksFulfillmentKey}",
                order: 1,
                redeemInstruction: "",
                redeemInstructionCtaHandling: "",
                target: "",
                redeemInstructionRichText: "",
              },
              {
                title: "Terms and conditions",
                href: "https://www.alaskaair.com/search/?E={perksFulfillmentKey}&lead=tc",
                order: 2,
                redeemInstruction: "",
                redeemInstructionCtaHandling: "",
                target: "",
                redeemInstructionRichText: "",
              },
            ],
          },
        },
        {
          id: 22,
          perkSummary: "Wifi Pass 1",
          perkName: "WIFI_SINGLE_FLIGHT_PASS_1",
          perkSelectionTileTitle: "One (1) Wi-Fi pass",
          perkSelectionTileSubtitle: "",
          items: [],
          termsAndConditions: {
            title: "",
            redeemInstructionRichText: "",
          },
          pastPerksCardProps: {
            fields: [
              {
                title: "Book by",
                value: "benefitExpirationDate",
                order: 1,
              },
              {
                title: "Milestone",
                value: "milestoneRequiredMiles",
                order: 2,
              },
            ],
            links: [
              {
                title: "How to Redeem",
                href: "https://www.alaskaair.com/search?E=",
                order: 1,
                redeemInstructionRichText: "<div>Redeem code</div>",
                redeemInstructionCtaHandling: "onClick",
              },
            ],
          },
        },
        {
          id: 27,
          perkSummary: "$100 off an Alaska Lounge membership",
          items: [],
          perkName: "LOUNGE_MEMBERSHIP_100_DOLLARS_OFF_1",
          perkSelectionTileTitle: "$100 off an Alaska Lounge membership",
          perkSelectionTileSubtitle: "Get $100 off a lounge membership",
          termsAndConditions: {
            title: "About Lounge Discount",
            redeemInstructionRichText:
              '<p><strong>&nbsp;New EQM Earning</strong></p><p></p><p></p><ul><li><p><strong>Award travel: </strong>Members will receive 1 elite-qualifying mile for every mile flown on award travel, including segments operated by Alaska partners. Elite-qualifying miles are nonredeemable and cannot be used toward award travel.&nbsp;</p></li></ul><ul><li><p><strong>Non-air: </strong>Members will receive 1,000 elite-qualifying miles for every 3,000 miles earned across eligible non-airline transactions in the hotel, cruise, car rental, ride share, and everyday categories. Miles earned through transfer partners (including Bilt, hotel partner transfers, and other financial partners) are not eligible to earn elite-qualifying miles. Purchased, gifted, or transferred miles are not eligible to earn elite-qualifying miles. Elite-qualifying miles are nonredeemable and cannot be used toward award travel.&nbsp;</p></li></ul><ul><li><p><strong>Card: </strong>*Elite-Qualifying Miles: Primary cardholder earns 1 elite-qualifying mile (EQM) for every $3 spent in Net Purchases (exclusive of any fees, such as the annual fee) that post to eligible Alaska Airlines Visa consumer and business cards from January 1, 2025 through December 31, 2025, up to a maximum of 30,000 EQMs. Returns, credits and adjustments to this card will be deducted from purchases, even if this card was not the original payment method. Cash Advances and Balance Transfers are not considered purchases and do not apply for purposes of this offer. One individual can only earn a maximum of 30,000 EQMs via this campaign, even if they hold multiple Alaska Airlines Visa cards. EQMs are calculated at the beginning of each month for the prior months posted Net Purchases and will be posted to Alaska Airlines Mileage Plan® account within 4-6 weeks. To qualify for this offer, your credit card account must be open with active charging privileges. EQMs will not appear on your credit card statement. EQMs are non-redeemable and cannot be used toward award travel. Elite status is valid for the remainder of the calendar year in which it is earned, plus the following calendar year. The elite-qualifying miles program is owned and operated by Alaska Airlines. Bank of America is not responsible for fulfillment of this EQM offer and posting of miles directly to your Alaska Airlines Mileage Plan® account.&nbsp;</p></li></ul><p></p><p><strong>Perks Benefit Selection</strong></p><p></p><p>Benefit selection is valid only for members who met the published elite-qualifying miles threshold for each milestone. Members who earned status via promotions, status match, or status gifts are not eligible unless they earn the published number of elite-qualifying miles for each milestone. Qualified members may select the indicated number of options from the list of available benefits. Benefit options are subject to change without notice. Benefit selection is final, and your choice cannot be changed once selected. All Mileage Plan terms and conditions apply&nbsp;</p><p></p><p><strong>Accrual / Redemption Perks</strong></p><p></p><ul><li><p><strong>Bonus miles: </strong>Members selecting bonus miles will have the miles immediately deposited into their Mileage Plan account upon selection of this option. Bonus miles are not elite qualifying miles and do not count toward future elite status qualification.&nbsp;</p></li></ul><ul><li><p><strong>Rollover elite-qualifying miles:</strong> Members selecting rollover elite-qualifying miles will have the elite-qualifying miles deposited into their Mileage Plan account within the first month of the next program year. For members qualifying for a milestone in the current calendar year, the end of the program year is December 31 of the following calendar year. Rollover elite-qualifying miles are nonredeemable and cannot be used toward award travel. &nbsp;</p></li></ul><ul><li><p><strong>2X miles with non-air partners: </strong>If you select this benefit, you will receive double miles (up to 2,000) for all qualifying non-airline transactions in the hotel, cruise, car rental, ride share, and everyday categories for 6 months, beginning on the date the benefit is selected. Miles earned through an Alaska Airlines credit card or transfer partners (including Bilt, hotel partner transfers, and other financial partners) are not eligible for double miles. Purchased, gifted, or transferred miles are not eligible for double miles. Bonus miles are not elite qualifying miles and do not count toward future elite status qualification.&nbsp;</p></li></ul><ul><li><p><strong>Extras mileage discount:</strong> Members will receive a discount code valid for a fixed number of miles off an Extras redemption through extras.alaskaair.com. Discount code must be used at checkout. Any residual value is forfeited upon redemption.&nbsp;</p></li></ul><p></p><p></p><p><strong>Status Perks</strong></p><p></p><ul><li><p><strong>Try status for a trip:</strong> If you select this benefit option, you will receive the indicated elite status for 14 days from the date of selection. &nbsp;</p></li></ul><ul><li><p><strong>Give status for a trip:</strong> If you select this benefit option, the individual you nominate will receive the indicated elite status for 14 days from the date of selection.&nbsp;</p></li></ul><ul><li><p><strong>Gift status:</strong> If you select this benefit option, the individual you nominate to status will receive the indicated elite status for through the end of the current program year if selected prior to October 1 and through the next program year if selected on or after October 1. For members qualifying for a milestone in the current calendar year, the end of the next program year is December 31 of the following calendar year.\u202F&nbsp;</p></li></ul><p></p><p><strong>Onboard Perks</strong></p><p></p><ul><li><p><strong>Complimentary pre-order food item:</strong> Members will receive one complimentary pre-order meal or snack when traveling in the Main Cabin or Premium Class. Pre-orders are available through the Alaska mobile app or through alaskaair.com from 2 weeks to 20 hours prior to your flight. Please note, if you change your flights, your meal choices won’t transfer to your new flight. You’ll need to pre-order meals under your new reservation. &nbsp;</p></li></ul><ul><li><p><strong>Complimentary Wi-Fi session: </strong>Member will receive a complimentary Wi-Fi session on an Alaska Airlines-marketing flight operated by Alaska, Horizon Air, or Skywest Airlines. Guest must be traveling to access complimentary Wi-Fi. Inflight Wi-Fi may not be available on all flights and speeds are not guaranteed. All Intelsat Inflight LLC (formerly Gogo Inflight)\u202F<a href="https://content.gogoair.com/terms/?lang=en_US"><u>terms and conditions</u></a>\u202Fapply.&nbsp;</p></li></ul><ul><li><p><strong>Complimentary Wi-Fi on every flight:</strong> Member will receive one complimentary Wi-Fi session on all Alaska Airlines-marketed flights operated by Alaska, Horizon Air or SkyWest Airlines, valid for one year from the date of selection. Guest must be traveling to access complimentary Wi-Fi. No refunds will be given to existing monthly or annual Wi-Fi pass members for any periods of overlap between their paid membership and their benefit membership. Inflight Wi-Fi may not be available on all flights and speeds are not guaranteed. All Intelsat Inflight LLC (formerly Gogo Inflight)\u202F<a href="https://content.gogoair.com/terms/?lang=en_US"><u>terms and conditions</u></a>\u202Fapply.&nbsp;</p></li></ul><p></p><p><strong>Alaska Lounge Perks</strong></p><ul><li><p><strong>Alaska Lounge membership discount:</strong> Valid for $100 off the purchase of an annual Alaska Lounge or Lounge+ membership. Not combinable with other Alaska Lounge or Lounge+ membership discounts, including the Alaska Visa Signature® consumer or Visa ® Business cardholder $100 off Lounge+ benefit.&nbsp;</p></li></ul><ul><li><p><strong>Alaska Lounge Pass:</strong> This benefit gives Day Pass entry to all Alaska Lounge locations. Guest must present a valid boarding pass for a flight that day on Alaska, a fellow <strong>one</strong>world® member airline, or one of our additional global partners. To redeem Alaska Lounge day passes, visit the Alaska Lounge and provide your Mileage Plan number or voucher code to the Concierge. You are welcome to share your Alaska Lounge day passes with friends or family. If you do share, please share the voucher code (available in "my account" under "Alaska Lounge passes.") Please do not share your Mileage Plan number. To ensure account security, we cannot access a member\'s account without the member present.&nbsp;</p></li></ul><ul><li><p><strong>Alaska Lounge+ Membership:</strong> You will receive a membership that allows you and your immediate family or up to two guests access when traveling with you. Membership duration is one year from your selection date. Existing Alaska Lounge or Lounge+ members will have their membership extended for any periods of overlap between their paid membership and their gifted membership. All Alaska Lounge+ membership terms and conditions apply. See our locations page for details. "Immediate family" is defined as your spouse or domestic partner and children (under 21 years of age).&nbsp;</p></li></ul><p></p><p><strong>Flight Booking Perks</strong></p><p></p><ul><li><p><strong>Upgrade certificates:</strong> First Class upgrades are booked in U service class and are subject to availability (may not be available on all flights). Not available on certain deeply discounted fares including bulk or industry tickets. See full details.&nbsp;</p></li></ul><ul><li><p><strong>Discount code: </strong>If you select this benefit, you will receive a discount code valid for $25 off a new ticket purchase on Alaska Airlines. Discount not valid with any other discounts, including discount codes, My account online discount, coupons, discount programs, or other arrangements. All Mileage Plan conditions of membership apply. Discount code offer is valid for $25 off a new ticket purchase on Alaska Airlines and flights operated on behalf of Alaska Airlines by Horizon Air and SkyWest. Not valid on flights to or from Prudhoe Bay (SCC). Ticket must be purchased on alaskaair.com within 120 days of date of selection. Valid for travel within 120 ays of date of selection. Passenger is responsible for all applicable taxes, fees, and surcharges, including checked baggage fees. Once ticketed, cancellation will result in the loss of the discount. Changes made after the \'Purchase By\' date will result in loss of the discount. All other changes and refunds may be allowed per the applicable fare rules. Once issued, tickets are not transferable.&nbsp;</p></li></ul><p></p><p><strong>Misc</strong></p><p></p><ul><li><p><strong>SAF contribution: Not part of announcement</strong></p></li></ul><ul><li><p><strong>Upgrade your next Avis rental:&nbsp; Not part of announcement </strong></p></li></ul><p></p>',
          },
          pastPerksCardProps: {
            fields: [
              {
                title: "Use by",
                value: "benefitExpirationDate",
                order: 1,
              },
              {
                title: "Milestone",
                value: "milestoneRequiredMiles",
                order: 2,
              },
            ],
            links: [
              {
                title: "Purchase membership",
                href: "https://www.alaskaair.com/content/airport-lounge/join-renew",
                order: 1,
                redeemInstruction: "",
                redeemInstructionCtaHandling: "",
                target: "_self",
                redeemInstructionRichText: "",
              },
            ],
          },
        },
        {
          id: 28,
          perkSummary: "1 Lounge Passes",
          perkSelectionTileTitle: "One (1) Lounge day pass",
          items: [],
          perkName: "LOUNGE_DAY_PASS_1",
          termsAndConditions: {
            title: "About Lounge day pass",
            redeemInstructionRichText:
              "<p><strong>Use by: </strong>Pass must be used within 120 days from the date of selection.</p><p>This benefit gives Day Pass entry to all Alaska Lounge locations. Guest must present a valid boarding pass for a flight that day on Alaska , a fellow <strong>one</strong>world® member airline, or one of our additional global partners. To redeem Alaska Lounge day passes, visit the Alaska Lounge and provide your Mileage Plan number or voucher code to the Concierge. You are welcome to share your Alaska Lounge day passes with friends or family. If you do share, please share the voucher code (available in &quot;my account&quot; under &quot;Alaska Lounge passes.&quot;) Please do not share your Mileage Plan number. To ensure account security, we cannot access a member's account without the member present.</p>",
          },
          pastPerksCardProps: {
            fields: [
              {
                title: "Use by",
                value: "benefitExpirationDate",
                order: "1",
              },
              {
                title: "Milestone",
                value: "milestoneRequiredMiles",
                order: "2",
              },
            ],
            links: [
              {
                title: "Use your Lounge day pass",
                href: "https://www.alaskaair.com/lounge-membership/passes",
                order: "1",
              },
            ],
          },
        },
        {
          id: 29,
          perkSummary: "2 Lounge Passes",
          perkSelectionTileTitle: "Two (2) Lounge day passes",
          items: [],
          perkName: "LOUNGE_DAY_PASS_2",
          termsAndConditions: {
            title: "About Lounge day pass",
            redeemInstructionRichText:
              "<p><strong>Use by: </strong>Pass must be used within 120 days from the date of selection.</p><p>This benefit gives Day Pass entry to all Alaska Lounge locations. Guest must present a valid boarding pass for a flight that day on Alaska , a fellow <strong>one</strong>world® member airline, or one of our additional global partners. To redeem Alaska Lounge day passes, visit the Alaska Lounge and provide your Mileage Plan number or voucher code to the Concierge. You are welcome to share your Alaska Lounge day passes with friends or family. If you do share, please share the voucher code (available in &quot;my account&quot; under &quot;Alaska Lounge passes.&quot;) Please do not share your Mileage Plan number. To ensure account security, we cannot access a member's account without the member present.</p>",
          },
          pastPerksCardProps: {
            fields: [
              {
                title: "Use by",
                value: "benefitExpirationDate",
                order: "1",
              },
              {
                title: "Milestone",
                value: "milestoneRequiredMiles",
                order: "2",
              },
            ],
            links: [
              {
                title: "Use your Lounge day pass",
                href: "https://www.alaskaair.com/lounge-membership/passes",
                order: "1",
              },
            ],
          },
        },
        {
          id: 40,
          perkSummary: "Roll-over Elite Qualifying Miles",
          items: [],
          perkName: "Roll-over Elite Qualifying Miles",
          perkSelectionTileTitle: "Roll-over Elite Qualifying Miles",
          perkSelectionTileSubtitle: "Up to 10K EQM’s rolled over to next year",
          termsAndConditions: {
            title: "About Rollover EQMs",
            redeemInstructionRichText:
              '<p><strong>&nbsp;New EQM Earning</strong></p><p></p><p></p><ul><li><p><strong>Award travel:</strong>Members will receive 1 elite-qualifying mile for every mile flown on award travel, including segments operated by Alaska partners. Elite-qualifying miles are nonredeemable and cannot be used toward award travel.&nbsp;</p></li></ul><ul><li><p><strong>Non-air:</strong>Members will receive 1,000 elite-qualifying miles for every 3,000 miles earned across eligible non-airline transactions in the hotel, cruise, car rental, ride share, and everyday categories. Miles earned through transfer partners (including Bilt, hotel partner transfers, and other financial partners) are not eligible to earn elite-qualifying miles. Purchased, gifted, or transferred miles are not eligible to earn elite-qualifying miles. Elite-qualifying miles are nonredeemable and cannot be used toward award travel.&nbsp;</p></li></ul><ul><li><p><strong>Card:</strong>*Elite-Qualifying Miles: Primary cardholder earns 1 elite-qualifying mile (EQM) for every $3 spent in Net Purchases (exclusive of any fees, such as the annual fee) that post to eligible Alaska Airlines Visa consumer and business cards from January 1, 2025 through December 31, 2025, up to a maximum of 30,000 EQMs. Returns, credits and adjustments to this card will be deducted from purchases, even if this card was not the original payment method. Cash Advances and Balance Transfers are not considered purchases and do not apply for purposes of this offer. One individual can only earn a maximum of 30,000 EQMs via this campaign, even if they hold multiple Alaska Airlines Visa cards. EQMs are calculated at the beginning of each month for the prior months posted Net Purchases and will be posted to Alaska Airlines Mileage Plan® account within 4-6 weeks. To qualify for this offer, your credit card account must be open with active charging privileges. EQMs will not appear on your credit card statement. EQMs are non-redeemable and cannot be used toward award travel. Elite status is valid for the remainder of the calendar year in which it is earned, plus the following calendar year. The elite-qualifying miles program is owned and operated by Alaska Airlines. Bank of America is not responsible for fulfillment of this EQM offer and posting of miles directly to your Alaska Airlines Mileage Plan® account.&nbsp;</p></li></ul><p></p><p><strong>Perks Benefit Selection</strong></p><p></p><p>Benefit selection is valid only for members who met the published elite-qualifying miles threshold for each milestone. Members who earned status via promotions, status match, or status gifts are not eligible unless they earn the published number of elite-qualifying miles for each milestone. Qualified members may select the indicated number of options from the list of available benefits. Benefit options are subject to change without notice. Benefit selection is final, and your choice cannot be changed once selected. All Mileage Plan terms and conditions apply&nbsp;</p><p></p><p><strong>Accrual / Redemption Perks</strong></p><p></p><ul><li><p><strong>Bonus miles:</strong>Members selecting bonus miles will have the miles immediately deposited into their Mileage Plan account upon selection of this option. Bonus miles are not elite qualifying miles and do not count toward future elite status qualification.&nbsp;</p></li></ul><ul><li><p><strong>Rollover elite-qualifying miles:</strong>Members selecting rollover elite-qualifying miles will have the elite-qualifying miles deposited into their Mileage Plan account within the first month of the next program year. For members qualifying for a milestone in the current calendar year, the end of the program year is December 31 of the following calendar year. Rollover elite-qualifying miles are nonredeemable and cannot be used toward award travel. &nbsp;</p></li></ul><ul><li><p><strong>2X miles with non-air partners:</strong>If you select this benefit, you will receive double miles (up to 2,000) for all qualifying non-airline transactions in the hotel, cruise, car rental, ride share, and everyday categories for 6 months, beginning on the date the benefit is selected. Miles earned through an Alaska Airlines credit card or transfer partners (including Bilt, hotel partner transfers, and other financial partners) are not eligible for double miles. Purchased, gifted, or transferred miles are not eligible for double miles. Bonus miles are not elite qualifying miles and do not count toward future elite status qualification.&nbsp;</p></li></ul><ul><li><p><strong>Extras mileage discount:</strong>Members will receive a discount code valid for a fixed number of miles off an Extras redemption through extras.alaskaair.com. Discount code must be used at checkout. Any residual value is forfeited upon redemption.&nbsp;</p></li></ul><p></p><p></p><p><strong>Status Perks</strong></p><p></p><ul><li><p><strong>Try status for a trip:</strong>If you select this benefit option, you will receive the indicated elite status for 14 days from the date of selection. &nbsp;</p></li></ul><ul><li><p><strong>Give status for a trip:</strong>If you select this benefit option, the individual you nominate will receive the indicated elite status for 14 days from the date of selection.&nbsp;</p></li></ul><ul><li><p><strong>Gift status:</strong>If you select this benefit option, the individual you nominate to status will receive the indicated elite status for through the end of the current program year if selected prior to October 1 and through the next program year if selected on or after October 1. For members qualifying for a milestone in the current calendar year, the end of the next program year is December 31 of the following calendar year. &nbsp;</p></li></ul><p></p><p><strong>Onboard Perks</strong></p><p></p><ul><li><p><strong>Complimentary pre-order food item:</strong>Members will receive one complimentary pre-order meal or snack when traveling in the Main Cabin or Premium Class. Pre-orders are available through the Alaska mobile app or through alaskaair.com from 2 weeks to 20 hours prior to your flight. Please note, if you change your flights, your meal choices won’t transfer to your new flight. You’ll need to pre-order meals under your new reservation. &nbsp;</p></li></ul><ul><li><p><strong>Complimentary Wi-Fi session:</strong>Member will receive a complimentary Wi-Fi session on an Alaska Airlines-marketing flight operated by Alaska, Horizon Air, or Skywest Airlines. Guest must be traveling to access complimentary Wi-Fi. Inflight Wi-Fi may not be available on all flights and speeds are not guaranteed. All Intelsat Inflight LLC (formerly Gogo Inflight) <a href="https://content.gogoair.com/terms/?lang=en_US"><u>terms and conditions</u></a> apply.&nbsp;</p></li></ul><ul><li><p><strong>Complimentary Wi-Fi on every flight:</strong>Member will receive one complimentary Wi-Fi session on all Alaska Airlines-marketed flights operated by Alaska, Horizon Air or SkyWest Airlines, valid for one year from the date of selection. Guest must be traveling to access complimentary Wi-Fi. No refunds will be given to existing monthly or annual Wi-Fi pass members for any periods of overlap between their paid membership and their benefit membership. Inflight Wi-Fi may not be available on all flights and speeds are not guaranteed. All Intelsat Inflight LLC (formerly Gogo Inflight) <a href="https://content.gogoair.com/terms/?lang=en_US"><u>terms and conditions</u></a> apply.&nbsp;</p></li></ul><p></p><p><strong>Alaska Lounge Perks</strong></p><ul><li><p><strong>Alaska Lounge membership discount:</strong>Valid for $100 off the purchase of an annual Alaska Lounge or Lounge+ membership. Not combinable with other Alaska Lounge or Lounge+ membership discounts, including the Alaska Visa Signature® consumer or Visa ® Business cardholder $100 off Lounge+ benefit.&nbsp;</p></li></ul><ul><li><p><strong>Alaska Lounge Pass:</strong>This benefit gives Day Pass entry to all Alaska Lounge locations. Guest must present a valid boarding pass for a flight that day on Alaska, a fellow<strong>one</strong>world® member airline, or one of our additional global partners. To redeem Alaska Lounge day passes, visit the Alaska Lounge and provide your Mileage Plan number or voucher code to the Concierge. You are welcome to share your Alaska Lounge day passes with friends or family. If you do share, please share the voucher code (available in "my account" under "Alaska Lounge passes.") Please do not share your Mileage Plan number. To ensure account security, we cannot access a member\'s account without the member present.&nbsp;</p></li></ul><ul><li><p><strong>Alaska Lounge+ Membership:</strong>You will receive a membership that allows you and your immediate family or up to two guests access when traveling with you. Membership duration is one year from your selection date. Existing Alaska Lounge or Lounge+ members will have their membership extended for any periods of overlap between their paid membership and their gifted membership. All Alaska Lounge+ membership terms and conditions apply. See our locations page for details. "Immediate family" is defined as your spouse or domestic partner and children (under 21 years of age).&nbsp;</p></li></ul><p></p><p><strong>Flight Booking Perks</strong></p><p></p><ul><li><p><strong>Upgrade certificates:</strong>First Class upgrades are booked in U service class and are subject to availability (may not be available on all flights). Not available on certain deeply discounted fares including bulk or industry tickets. See full details.&nbsp;</p></li></ul><ul><li><p><strong>Discount code:</strong>If you select this benefit, you will receive a discount code valid for $25 off a new ticket purchase on Alaska Airlines. Discount not valid with any other discounts, including discount codes, My account online discount, coupons, discount programs, or other arrangements. All Mileage Plan conditions of membership apply. Discount code offer is valid for $25 off a new ticket purchase on Alaska Airlines and flights operated on behalf of Alaska Airlines by Horizon Air and SkyWest. Not valid on flights to or from Prudhoe Bay (SCC). Ticket must be purchased on alaskaair.com within 120 days of date of selection. Valid for travel within 120 ays of date of selection. Passenger is responsible for all applicable taxes, fees, and surcharges, including checked baggage fees. Once ticketed, cancellation will result in the loss of the discount. Changes made after the \'Purchase By\' date will result in loss of the discount. All other changes and refunds may be allowed per the applicable fare rules. Once issued, tickets are not transferable.&nbsp;</p></li></ul><p></p><p><strong>Misc</strong></p><p></p><ul><li><p><strong>SAF contribution: Not part of announcement</strong></p></li></ul><ul><li><p><strong>Upgrade your next Avis rental:&nbsp; Not part of announcement</strong></p></li></ul><p></p>',
          },
          pastPerksCardProps: {
            fields: [
              {
                title: "Selected",
                value: "selectionDate",
                order: "1",
              },
              {
                title: "Milestone",
                value: "milestoneRequiredMiles",
                order: "2",
              },
            ],
            links: [],
          },
        },
      ],
    },
    {
      milestones: [
        {
          id: 0,
          name: "",
          milestoneHeading: "Mileage Plan Member",
          milestoneDetails: "",
          milestoneTrackerMessage: "to the 10k perks milestone",
          chips: {
            backgroundColor: "ds-color-excursion-white-900",
            subtractColor: "",
            textColor: "ds-color-excursion-gray-900",
            title: "30K Milestone",
          },
          expandingButton: {
            expandedText: "Less benefits",
            unexpandedText: "More benefits",
            textColor: "#000",
          },
          summary: "sample summary",
          summaryRichText: `<div class="benefit-item-container" data-testid="perk-benefit-item"><ul class="name"><li class="bullet-item">Earn miles with Alaska, Hawaiian, oneworld® Alliance member airlines and       our Global Partners</li></ul></div><div class="benefit-item-container" data-testid="perk-benefit-item"><ul class="name"><li class="bullet-item">Miles never expire</li></ul></div><div class="benefit-item-container" data-testid="perk-benefit-item"><ul class="name"><li class="bullet-item">Global award travel starts at 5,000 miles one way</li></ul></div><div class="benefit-item-container" data-testid="perk-benefit-item"><ul class="name"><li class="bullet-item">Earn miles with hotel, car rental, rideshare, and everyday partners</li></ul></div><div class="benefit-item-container" data-testid="perk-benefit-item"><ul class="name"><li class="bullet-item">Use your miles for hotel stays, car rentals, charitable causes, and experiences</li></ul></div>`,
        },
        {
          id: 1,
          name: "10K",
          milestoneHeading: "10K Milestone",
          milestoneDetails: "",
          milestoneTrackerMessage: "to the 10k milestone",
          chips: {
            backgroundColor: "ds-color-excursion-white-900",
            subtractColor: "",
            textColor: "ds-color-excursion-gray-900",
            title: "10K Milestone",
          },
          expandingButton: {
            expandedText: "Less benefits",
            unexpandedText: "More benefits",
            textColor: "#000",
          },
          summary: "sample summary",
          summaryRichText: `<div class="benefit-item-container" data-testid="perk-benefit-item"><ul class="name"><li class="bullet-item">Earn miles with Alaska, Hawaiian, oneworld® Alliance member airlines and       our Global Partners</li></ul></div><div class="benefit-item-container" data-testid="perk-benefit-item"><ul class="name"><li class="bullet-item">Miles never expire</li></ul></div><div class="benefit-item-container" data-testid="perk-benefit-item"><ul class="name"><li class="bullet-item">Global award travel starts at 5,000 miles one way</li></ul></div><div class="benefit-item-container" data-testid="perk-benefit-item"><ul class="name"><li class="bullet-item">Earn miles with hotel, car rental, rideshare, and everyday partners</li></ul></div><div class="benefit-item-container" data-testid="perk-benefit-item"><ul class="name"><li class="bullet-item">Use your miles for hotel stays, car rentals, charitable causes, and experiences</li></ul></div>`,
        },
        {
          id: 2,
          name: "30K",
          milestoneHeading: "30K Milestone",
          milestoneDetails:
            "You will receive the following when you reach your 30k status. You can use this benefits for every flight while you hold this status.",
          milestoneTrackerMessage: "to the 30k perks milestone",
          chips: {
            backgroundColor: "ds-color-excursion-white-900",
            subtractColor: "",
            textColor: "ds-color-excursion-gray-900",
            title: "MVP&reg;30K",
          },
          perksLadderInfo: {
            text: "Coming in 2025",
            showIf: true,
          },
          expandingButton: {
            expandedText: "Less perks option",
            unexpandedText: "More perks option",
            textColor: "#000",
          },
          summary: "sample summary",
        },
        {
          id: 3,
          name: "55K",
          milestoneHeading: "55K Milestone",
          milestoneTrackerMessage: "to the 55K Milestone",
          milestoneDetails: "You'll Unlock two one-time use perks at the 55K milestone.",
          chips: {
            backgroundColor: "ds-color-excursion-white-900",
            subtractColor: "",
            textColor: "ds-color-excursion-gray-900",
            title: "MVP&reg;GOLD 55K",
          },
          perksLadderInfo: {
            text: "Coming in 2025",
            showIf: true,
          },
          expandingButton: {
            expandedText: "Less perks option",
            unexpandedText: "More perks option",
            textColor: "#000",
          },
          summary: "sample summary",
        },
        {
          id: 5,
          name: "30K",
          milestoneHeading: "30K Milestone",
          milestoneTrackerMessage: "to the 30K Milestone",
          milestoneSummary:
            "You will recieved the following when you reach your 30k status. You can use this benefits for every flight while you hold this status.",
          chips: {
            backgroundColor: "ds-color-excursion-white-900",
            subtractColor: "",
            textColor: "ds-color-excursion-gray-900",
            title: "MVP&reg;30K",
          },
          perksLadderInfo: {
            text: "Coming in 2025",
            showIf: true,
          },
          expandingButton: {
            expandedText: "Less perks option",
            unexpandedText: "More perks option",
            textColor: "#000",
          },
          summary: "sample summary",
        },
        {
          id: 6,
          name: "150k",
          milestoneHeading: "150K Milestone",
          milestoneTrackerMessage: "to the 150K Milestone",
          milestoneSummary: "You'll Unlock two one-time use perks at the 150k milestone.",
          chips: {
            backgroundColor: "ds-color-excursion-blue-300",
            subtractColor: "ds-color-excursion-green-300",
            textColor: "ds-color-excursion-gray-90",
            title: "MVP&reg;GOLD 150K",
          },
          perksLadderInfo: {
            text: "Coming in 2025",
            showIf: true,
          },
          expandingButton: {
            expandedText: "Less perks option",
            unexpandedText: "More perks option",
            textColor: "#000",
          },
        },
        {
          id: 7,
          name: "200k",
          milestoneHeading: "200k Milestone",
          milestoneTrackerMessage: "to the 200K Milestone",
          milestoneSummary:
            "You will recieved the following when you reach your 200k status. You can use this benefits for every flight while you hold this status.",
          chips: {
            backgroundColor: "ds-color-excursion-blue-800",
            subtractColor: "ds-color-excursion-orange-500",
            textColor: "ds-color-excursion-orange-300",
            title: "MVP&reg;GOLD 200K",
          },
          perksLadderInfo: {
            text: "Coming in 2025",
            showIf: true,
          },
          expandingButton: {
            expandedText: "Less perks option",
            unexpandedText: "More perks option",
            textColor: "#000",
          },
          summary: "",
        },
        {
          id: 9,
          name: "20K",
          milestoneHeading: "20K Milestone",
          milestoneDetails: "You'll unlock two one-time use perks at the 20k milestone.",
          milestoneTrackerMessage: "to MVP 20K status",
          chips: {
            backgroundColor: "ds-color-excursion-blue-300",
            subtractColor: "ds-color-excursion-green-300",
            textColor: "ds-color-excursion-gray-900",
            title: "MVP",
          },
          expandingButton: {
            expandedText: "Less benefits",
            unexpandedText: "More benefits",
            textColor: "#000",
          },
          summary: "sample 20K summary",
        },
      ],
    },
    {
      perksLadder: {
        title: "Mileage Plan Benefits",
        webTitle: "All Benefits",
        titleBackgroundColor: "ds-color-excursion-blue-900",
        backgroundColor: "ds-color-excursion-blue-100",
        buttonText: "Back to Alaska Perks",
        buttonTextColor: "Gray-white",
        buttonBackgroundColor: "Blue-blue-background-800",
        link: {
          text: "Mileage Plan terms and conditions",
          textColor: "#000",
          href: "https://www.alaskaair.com/content/mileage-plan/terms-and-conditions?msockid=0a4db4e73b8564c21535a7323a6b6585",
        },
      },
    },
    {
      errorPage: {
        backgroundColor: "Green/green-background-25",
        title: "Something went wrong",
        subTitle: "Your perk selections were unsuccessful.",
        oneSelectionTitle: "Your selection of {perk} can’t be completed right now.",
        twoSelectionTitle: "{perk1} and {perk2} selection could not be completed.",
        oneOfTwoSelectionTitle: "{perk} selection was unsuccessful.",
        retryButtonTitle: "Try again",
        retryButtonTextColor: "Gray-white",
        retryButtonBackgroundColor: "ds-color-container-ui-primary-default-default",
        backHubButtonTitle: "Back",
        backHubButtonTextColor: "Gray-white",
        backHubButtonBorderColor: "ds-color-container-ui-primary-default-default",
      },
    },
    {
      perksRedemptionPage: {
        background: "ds-color-excursion-blue-200",
        buttonText: "Select",
        buttonTextColor: "Gray-white",
        buttonBackgroundColor: "Blue-blue-background-800",
        perks: [
          {
            perkId: "37",
            navTitle: "Nominate me  for MVP Gold status",
            redemptionCtaPage: {
              title: "things",
              subtitleRichText: "test",
              datePickerInfoTop: "top",
              datePickerInfoBottom: "bottom",
              datePickerHint: "hint",
              submitButtonText: "Submit",
              field: [
                {
                  fieldName: "Bob",
                  fieldHint: "Hint",
                  validationRegex: "regex",
                  errorHint: "error",
                  fieldInstruction: "do it correctly",
                },
              ],
            },
            redemptionFailurePage: {
              failureInfoRichText: "Perk redemption failed",
              failureInfoTitle: "Please Try Again",
              failureBackButton: "Back",
            },
            redemptionSuccessPage: {
              successBackButton: "All done",
              successTitle: "Congrats",
              successSubtitle: "Your perk redemption successful!",
            },
            redemptionConfirmationPage: {
              reviewText: "review",
              title: "title",
              subtitle: "subtitle",
              iconSubtitle: "icon",
              confirmButtonCta: "confirm",
              backButtonCta: "back",
              reviewFields: [
                {
                  name: "Bob",
                  displayName: "Robert",
                  order: "yes",
                },
              ],
            },
          },
        ],
      },
    },
  ],
  Error: { message: null },
  isLoadingMobileContent: true,
};

const initialState = {
  isLoadingToken: false,
  Token: {
    Value: "",
    Guid: "",
    MileagePlanNumber: "",
    IsSuperUser: false,
  },
  MVPGoldNominationDetails: {
    FirstName: "",
    LastName: "",
    MileagePlanNumber: "",
    Email: "",
  },
  MileagePlanDetails: {
    MileagePlanNumber: "",
    FirstName: "",
    LastName: "",
    miles: "",
    TierName: "",
    TierCode: "",
    MemberSelectionId: 0,
    MilestoneId: 0,
    MilestoneName: "",
    Email: "",
    TierEndDate: "",
    ChoiceSelectedStatus: "",
    HowTier: "",
    MP100KChoice: "",
    MemberBalance: 0,
    MilestoneAchievementDate: "",
    SelectionExpirationDate: "",
    IsEligibleFor100KChoiceSelection: false,
    asoaMiles: 0,
    oneWorldTier: "",
    Perks: [
      {
        PerkBenefitId: null,
        PerkName: "",
        PerkDescription: "",
        isEnabled: null,
      },
    ],
  },
  Error: { message: null },
  SelectedChoiceMade: "",
  NominatedName: "",
};

export type AccountStateType = typeof initialState;
export type ContentStateType = typeof initialContentState;

export default initialState;
